<div class="wa-flank:end">
  <div>{{ staffmember().last_name }}, {{ staffmember().first_name }}</div>
  <div class="button-group-toolbar">
  <wa-button appearance="plain" label="fixing options" size="s" variant="neutral">
      <wa-icon name="ellipsis-vertical" variant="classic"></wa-icon>
    </wa-button>
  <wa-button (click)="unfix.emit(staffmember())" appearance="plain" label="to regular pool" size="s"
               variant="warning">
      <wa-icon name="right-from-line" variant="classic"></wa-icon>
    </wa-button>
    </div>
</div>
